<template>
  <!-- 消息管理 -->
 <div class="app-container">
   <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true" ref="" class="demo-form-inline" label-width="110px" size="mini">
        <div class="formItemBox">
            <el-form-item label="标题:"  prop="versionTitle"  >
              <el-input  placeholder=""   maxlength="30" v-model="searchFrom.versionTitle"  ></el-input>
            </el-form-item>
            <el-form-item label="版本时间:" prop="versionTime">
                <el-date-picker
                  v-model="searchFrom.versionTime"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :default-time="['00:00:00', '23:59:59']"
                ></el-date-picker>
              </el-form-item>
        </div>
       <div class="searchBtnBox">
            <div>
              <el-form-item btnCode="00JP009B001"  v-if="btnFlg[0]">
                <el-button type="primary" @click="searchFn">查询</el-button>
              </el-form-item>
              <el-form-item v-if="btnFlg[1]">
                <el-button type="primary" @click="resetForm('searchFrom')">重置</el-button>
              </el-form-item>
              <el-form-item v-if="btnFlg[2]">
                <el-button type="primary" @click="addFN">新增</el-button>
              </el-form-item>
            </div>
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  class="tableComent"  @selection-change='selectGoods' height="100%" style="width: 100%" center border>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" fixed prop="date" width="55" label="序号"></el-table-column>
        <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <div>
              <el-button type="text" size="mini" v-if="btnFlg[3]"  @click="editFN(scope.row)">修改</el-button>
              <el-button type="text" size="mini" v-if="btnFlg[4]" @click="delFN(scope.row)">删除</el-button>
              <el-button type="text" size="mini"  @click="xiangQingFN(scope.row)">详情</el-button>
              </div>
            </template>
        </el-table-column>
        <el-table-column property="versionTitle" min-width="330"  :formatter="emptyFn"   label="标题"></el-table-column>
        <el-table-column property="versionNo" min-width="230"  :formatter="emptyFn"   label="版本号"></el-table-column>
        <el-table-column property="createUser"  min-width="240"  :formatter="emptyFn"   label="创建人"></el-table-column>
        <el-table-column property="versionTime" label="版本时间" min-width="170"  align="center" :formatter="dateTimeFormat" ></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[25,50,100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
     <el-dialog  :title="isAdd?'新建':'编辑'"  :visible.sync="addMark" width="800px" class="detail"  :close-oni-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
       <el-form  :model="addFrom" ref="addFrom" :rules="rules" class="jiaoyan" :inline="true" label-width="100px" size="mini">
            <el-form-item label="标题:"  prop="versionTitle"  >
              <el-input  placeholder=""   maxlength="30" v-model="addFrom.versionTitle"  style="width:630px" ></el-input>
            </el-form-item>
            <br>
            <!-- <el-form-item label="版本号:"  prop="versionNo"  >
              <el-input  placeholder=""   maxlength="30" v-model="addFrom.versionNo"   ></el-input>
            </el-form-item> -->
            <el-form-item label="版本时间:" prop="versionTime">
              <el-date-picker  v-model="addFrom.versionTime"  format="yyyy-MM-dd HH:mm:ss"  value-format="timestamp"
                  type="datetime" ></el-date-picker>
            </el-form-item>
            <tinymce v-model="addFrom.versionContent" v-if="addMark" :height="500" />
        </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addMark = false">取 消</el-button>
        <el-button type="primary" @click="saveFn">确定</el-button>
      </span>
   </el-dialog>
   <el-dialog  title="查看详情"  :visible.sync="xiangQingMark" width="800px" class="detail"  :close-oni-click-modal="false"
       @close="closeDialog1" :close-on-press-escape="false" center>
      <div class="contBox">
        <div class="title item">{{rowData.versionTitle}}</div>
          <div class="box item">
              <div>版本号：{{rowData.versionNo}}<span>&emsp;&emsp;&emsp;版本时间：{{rowData.versionTime|dateFormat}}</span></div>
          </div>
        <div v-html="rowData.versionContent"></div>
        <hr />
      </div>
      <span slot="footer" class="dialog-footer">
         <el-button @click="xiangQingMark = false">关闭</el-button>
      </span>
   </el-dialog>
 </div>

</template>

<script>
import { getBtn } from '@/utils/getButton'
import { emptyFn, dateTimeFormat, getLastMonth } from '@/utils/util'
import {
  findVersionManagementList, // 列表
  deleteVersionManagement,
  operationVersionManagement// 新建
} from '@/api/newTMS'
import Tinymce from '@/components/Tinymce'
export default {
  components: { Tinymce },
  data () {
    return {
      data: {

      },
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      h: '500px',
      // 查询
      searchFrom: {
        pageNo: 1,
        pageSize: 50,
        orderBy: false
      },
      tableList: [],
      loading: 'false',
      total: 0,
      addFrom: { },
      addMark: false,
      xiangQingMark: false,
      xzyhMark: false,
      isAdd: false,
      rowData: {},
      userList: [],
      rules: {
        versionTitle: { required: true, message: '请输入标题', trigger: 'blur' },
        versionNo: { required: true, message: '请输入版本号', trigger: 'blur' },
        versionTime: { required: true, message: '请选择版本时间', trigger: 'blur' }
      },
      btnFlg: [],
      btnIdArr: ['01N01C0100', '01N01C0200', '01N01C0300', '01N01C0400', '01N01C0500']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/versionManage')
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 166) + 'px'
  },
  methods: {
    // 删除
    delFN (row) {
      this.$confirm('是否执行删除操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        deleteVersionManagement({ ids: [row.id] }).then(res => {
          loading.close()
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 详情
    xiangQingFN (row) {
      this.rowData = row
      this.xiangQingMark = true
    },
    // 新建
    addFN () {
      this.addMark = true
      this.addFrom = {
        versionTime: new Date().getTime()
      }

      this.isAdd = true
    },
    // 编辑
    editFN (row) {
      this.isAdd = false
      this.addFrom = { ...row }
      this.addMark = true
    },
    saveFn (n) {
      this.$refs.addFrom.validate((valid) => {
        if (valid) {
          if (!this.addFrom.versionContent) {
            this.$alert('请输入消息内容', '系统提示')
            return
          }
          operationVersionManagement(this.addFrom).then(res => {
            this.$message({
              message: '成功',
              type: 'success'
            })
            this.addMark = false
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                this.loading = false
              }
            })
          })
        }
      })
    },
    closeDialog1 () {
      this.$refs.tree.setCheckedKeys([])
    },
    // 查选
    searchFn () {
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {

    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      if (this.searchFrom.versionTime) {
        this.searchFrom.versionTimeStart = this.searchFrom.versionTime[0]
        this.searchFrom.versionTimeEnd = this.searchFrom.versionTime[1]
      } else {
        this.searchFrom.versionTimeStart = ''
        this.searchFrom.versionTimeEnd = ''
      }
      this.loading = true
      findVersionManagementList(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            this.loading = false
          }
        })
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    billDetails (row) {
      this.$router.push({ name: 'billDetails', query: { billId: row.id } })
    },
    // 获取年月
    getLastMonth () { // 获取上个月日期
      var date = new Date()
      var year = date.getFullYear()
      var month = date.getMonth() < 10 ? '0' + date.getMonth() : date.getMonth()
      if (month == 0) {
        year = year - 1
        month = 12
      }
      return year + '-' + month
    },
    // 重置
    resetForm (formName) {
      // debugger
      // this.$refs[formName].resetFields()
      // this.searchFrom.createTime=null
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50
      }
    },
    closeDialog () {
      this.addFrom = { userList: [] }
      this.CHFrom = {}
    }
  }
}
</script>

<style scoped lang='less'>
.inpBox .el-date-editor{
      width: 350px!important;
}
/deep/.el-link.el-link--primary{
  color: #0c46a2;
    font-size: 12px;
}

.searchBtnBox{
   width: 100%;
  display: flex;
  justify-content: space-between;
}
.el-tag{
  margin-right: 6px;
    margin-bottom: 6px;
}
.contBox{
  width: 700px;
  margin: 0 auto;
  .title{
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 20px;

  }
  .item{
    text-align: center;
  }
  .box{
    display: flex;
    justify-content: center;
  }
}
 /deep/.el-form {
  width: 100%;
 }
 .formItemBox{
    /deep/.el-form-item{
      width: 24%;
    }
  }
</style>
